import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { registerScreens } from "../util/util";
import { useHistory, withRouter } from "react-router-dom";
import { initializePayment } from "../application/application.service";
import fetchApi from "../services/fetch/fetch.service";

const defaultState = {
    purchaserForm: {},
    purchaserFormValid: false,
    currentScreen: null,
    availableSteps: [],
    attendersForm: [],
    attendersFormValid: {},
    verificationForm: {},
    verificationFormValid: {},
    loginForm: {},
    isLoginFormValid: false,
    paymentGatewayForm: {},
    monriFormValues: {},
    errorMessage: null,
    loading: true
};

const defaultActions = {
    setPurchaserFormField: payload => {},
    setPurchaserFormValid: payload => {},
    changeScreen: payload => {},
    nextScreen: () => {},
    backScreen: () => {},
    initAttendersForm: payload => {},
    setAttendersFormValid: payload => {},
    setAttenderAtForm: (payload, index) => {},
    setVerificationFormValid: payload => {},
    setVerificationFormField: payload => {},
    setLoginForm: payload => {},
    setLoginFormValid: payload => {},
    setPaymentGatewayForm: payload => {},
    setMonriFormValues: payload => {},
    confirmPayment: payload => {},
    setErrorMessage: payload => {},
    setLoading: payload => {}
};

export const RegistrationContext = React.createContext({
    ...defaultState,
    ...defaultActions
});
export const RegistrationConsumer = RegistrationContext.Consumer;

const RegisterContext = props => {
    const [availableSteps, setAvailableSteps] = useState([true, false, false, false]);
    const [currentScreen, setCurrentScreenBase] = useState(registerScreens.ACCREDITATION_START);
    const [purchaserForm, setPurchaserForm] = useState({});
    const [purchaserFormValid, setPurchaserFormValid] = useState(false);
    const [loginForm, setLoginForm] = useState({
        code: localStorage.getItem("qrCode")
    });
    const [isLoginFormValid, setLoginFormValid] = useState(localStorage.getItem("qrCode")?.trim().length === 10 ? true : false);
    const [paymentGatewayForm, setPaymentGatewayForm] = useState(null);
    const [monriFormValues, setMonriFormValues] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const history = useHistory();
    const [loading, setLoading] = useState(true);

    const setPurchaserFormField = field => {
        setPurchaserForm(prevState => ({ ...prevState, ...field }));
    };

    const setCurrentScreen = currentScreen => {
        setCurrentScreenBase(currentScreen);
    };

    useEffect(() => {
        const decideWhatScreenToOpen = async () => {
            const code = localStorage.getItem("qrCode");
            if (code) {
                try {
                    await fetchApi.service().get(`${process.env.REACT_APP_API_ENDPOINT}api/accreditation/qrCode/${code}`);
                    setLoginForm({
                        code
                    });
                    changeScreen(registerScreens.QR_CODE, () => {
                        setLoading(false);
                    });
                } catch (e) {
                    changeScreen(registerScreens.ACCREDITATION_START);
                }
            }
            setTimeout(() => {
                setLoading(false);
            }, 0);
        };
        decideWhatScreenToOpen();
    }, []);

    useEffect(() => {
        if (history.location.state?.screen === "LOGIN") {
            setCurrentScreenBase(registerScreens.PURCHASER);
            setLoading(false);
        }
    }, [history]);

    const nextScreen = async isRegistered => {
        switch (currentScreen) {
            case registerScreens.ACCREDITATION_START:
                if (isRegistered) {
                    if (isLoginFormValid) {
                        setErrorMessage(null);
                        try {
                            await fetchApi.service().get(`${process.env.REACT_APP_API_ENDPOINT}api/accreditation/qrCode/${loginForm.code}`);
                            localStorage.setItem("qrCode", loginForm.code);
                            changeScreen(registerScreens.QR_CODE);
                        } catch (e) {
                            setErrorMessage("Nevalidan kod.");
                        }
                    }
                } else {
                    //TODO API CALL, send purchaser form and wait for
                    changeScreen(registerScreens.PURCHASER);
                }
                break;
            case registerScreens.PURCHASER:
                if (purchaserFormValid) {
                    try {
                        const { data } = await initializePayment({
                            fullName: purchaserForm.personInCharge,
                            email: purchaserForm.email,
                            phone: purchaserForm.phone,
                            companyName: purchaserForm.companyName,
                            companyAddress: purchaserForm.address,
                            companyJib: purchaserForm.companyIdentificationNumber,
                            attendanceType: purchaserForm.conferenceAttendType,
                            paymentType: purchaserForm.paymentType
                        });
                        if (purchaserForm.paymentType == "WIRE_PAYMENT") {
                            setTimeout(() => {
                                changeScreen(registerScreens.SUCCESSFUL_WIRE_PAYMENT);
                            }, 0);
                        } else if (purchaserForm.paymentType == "E_PAYMENT") {
                            setMonriFormValues(data);
                            setTimeout(() => {
                                changeScreen(registerScreens.CONFIRM_TERMS);
                            }, 0);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    //changeScreen(registerScreens.ATTENDERS);
                }
                break;
            case registerScreens.ATTENDERS:
                if (attendersFormValid) {
                    changeScreen(registerScreens.REGISTRATION_FEE);
                }
                break;
            case registerScreens.CONFIRM_TERMS:
                try {
                    if (purchaserFormValid) {
                        changeScreen(registerScreens.MONRI_PAGE);
                    }
                } catch (e) {
                    console.error(e);
                }
                break;
            case registerScreens.REGISTRATION_FEE:
                changeScreen(registerScreens.VERIFICATION);
                break;
            case registerScreens.VERIFICATION:
                break;
            default:
                break;
        }
    };

    const changeScreen = id => {
        switch (id) {
            case registerScreens.PURCHASER:
                setAvailableSteps([true, false, false, false]);
                setCurrentScreen(registerScreens.PURCHASER);
                break;
            case registerScreens.ATTENDERS:
                setAvailableSteps([true, true, false, false]);
                setCurrentScreen(registerScreens.ATTENDERS);
                break;
            case registerScreens.REGISTRATION_FEE:
                setAvailableSteps([true, true, true, false]);
                setCurrentScreen(registerScreens.REGISTRATION_FEE);
                break;
            case registerScreens.VERIFICATION:
                setAvailableSteps([true, true, true, true]);
                setCurrentScreen(registerScreens.VERIFICATION);
                break;
            case registerScreens.ACCREDITATION_START:
                setCurrentScreen(registerScreens.ACCREDITATION_START);
                break;
            case registerScreens.QR_CODE:
                setCurrentScreen(registerScreens.QR_CODE);
                break;
            case registerScreens.SUCCESSFUL_WIRE_PAYMENT:
                setCurrentScreen(registerScreens.SUCCESSFUL_WIRE_PAYMENT);
                break;
            case registerScreens.CONFIRM_TERMS:
                setCurrentScreen(registerScreens.CONFIRM_TERMS);
                break;
            case registerScreens.MONRI_PAGE:
                setCurrentScreen(registerScreens.MONRI_PAGE);
                break;
            default:
                break;
        }
    };

    const backScreen = () => {
        switch (currentScreen) {
            case registerScreens.VERIFICATION:
                setCurrentScreen(registerScreens.REGISTRATION_FEE);
                break;
            case registerScreens.REGISTRATION_FEE:
                setCurrentScreen(registerScreens.ATTENDERS);
                break;
            case registerScreens.ATTENDERS:
                setCurrentScreen(registerScreens.PURCHASER);
                break;
            case registerScreens.PURCHASER:
                break;
            default:
                break;
        }
    };

    const [attendersForm, setAttendersForm] = useState({ attenders: [] });
    const [attendersFormValid, setAttendersFormValid] = useState(false);

    const initAttendersForm = (attender, numberOfAttenders) => {
        setAttendersForm({ attenders: Array.from(Array(numberOfAttenders)).map(() => ({ ...attender })) });
    };
    const setAttenderAtForm = (attender, index) => {
        if (index >= 0) {
            setAttendersForm(prevState => {
                const newAttender = { ...prevState.attenders[index], ...attender };
                const newAttenders = [...prevState.attenders];
                newAttenders[index] = newAttender;
                return {
                    attenders: newAttenders
                };
            });
        }
    };

    const [verificationForm, setVerificationForm] = useState({});
    const [verificationFormValid, setVerificationFormValid] = useState(false);
    const setVerificationFormField = field => setVerificationForm(prevState => ({ ...prevState, ...field }));

    const state = {
        purchaserForm,
        purchaserFormValid,
        setPurchaserFormField,
        setPurchaserFormValid,
        currentScreen,
        availableSteps,
        changeScreen,
        nextScreen,
        backScreen,
        attendersForm,
        attendersFormValid,
        setAttendersFormValid,
        initAttendersForm,
        setAttenderAtForm,
        verificationForm,
        verificationFormValid,
        setVerificationFormField,
        setVerificationFormValid,
        isLoginFormValid,
        loginForm,
        setLoginFormValid,
        setLoginForm,
        paymentGatewayForm,
        setPaymentGatewayForm,
        monriFormValues,
        setMonriFormValues,
        errorMessage,
        setErrorMessage,
        loading,
        setLoading
    };

    return <RegistrationContext.Provider value={state}>{props.children}</RegistrationContext.Provider>;
};

RegisterContext.propTypes = {
    children: PropTypes.node.isRequired
};
export const useRegisterStateValue = () => React.useContext(RegistrationContext);

export default withRouter(RegisterContext);
